var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash aCenter jCenter fCol"},[_c('img',{staticClass:"logo light growFull",attrs:{"alt":"Vue logo","src":require("../assets/rimik.svg")}}),_c('div',{staticClass:"load"}),_c('zadak')],1)}
var staticRenderFns = []

export { render, staticRenderFns }